import { createFileRoute } from "@tanstack/react-router";

import { parsePresenterDebugSearch } from "~/features/gameSession/components/PresenterDebugView/presenterDebugSearch.ts";
import {
    resolvePresenterDebugSelection,
    toPresenterDebugSearch,
} from "~/features/gameSession/components/PresenterDebugView/presenterDebugUtils.ts";
import { PresenterDebugView } from "~/features/gameSession/components/PresenterDebugView/PresenterDebugView.tsx";

const PresenterDebugPage = () => {
    const navigate = Route.useNavigate();
    const selection = resolvePresenterDebugSelection(Route.useSearch());

    return (
        <PresenterDebugView
            {...selection}
            onChange={(change) => {
                navigate({ search: toPresenterDebugSearch({ ...selection, ...change }), replace: true });
            }}
        />
    );
};

export const Route = createFileRoute("/_auth/dev/presenter/")({
    validateSearch: parsePresenterDebugSearch,
    component: PresenterDebugPage,
});
